import script from "./workflow-review-sidepane-tags-filter.vue?vue&type=script&setup=true&lang=js"
export * from "./workflow-review-sidepane-tags-filter.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__